var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
const RowStyle = styled.div `
  position: relative;
  border-radius: ${props => props.theme.borders.borderRadius};
  width: auto;
  height: auto;
  cursor: pointer;
  border-bottom: ${props => props.theme.utils.borderColor(props.theme.utils.getColor('grey'))};
  padding: ${props => props.theme.paddingsMargins.themePadding};
  ${props => props.transition &&
    css `
      transition: box-shadow 200ms ease-in-out;

      &:hover {
        border-bottom: 1px solid transparent;
        box-shadow: ${props.theme.boxes.boxShadowTransition};
      }
    `}
`;
const Row = (_a) => {
    var { transition = true, children } = _a, props = __rest(_a, ["transition", "children"]);
    return _jsx(RowStyle, Object.assign({ transition: transition }, props, { children: children }));
};
export default Row;
